import React from "react";
import { BrowserRouter } from "react-router-dom";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.js";
import "../src/style/css/feather.css";
import "../src/style/css/line-awesome.min.css";
import "../src/style/scss/main.scss";
import "../src/style/icons/fontawesome/css/fontawesome.min.css";
import "../src/style/icons/fontawesome/css/all.min.css";
// New master design (after main.scss so it wins ties): axo-master.css holds the
// shared tokens and the .ax-master page theme; product-master.css the product screen.
import "../src/style/css/axo-master.css";
import "../src/style/css/product-master.css";
import { createRoot } from "react-dom/client";
import { Toaster } from "react-hot-toast";
import { Provider } from "react-redux";
import { store, persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import AllRoutes from "./Router/router.jsx";
import axios from "axios";
import TranslateComponent from "./Context/TranslationComponent.jsx";



// axios.interceptors.request.use(
//   (config) => {
//     const requireheader = config?.requireheader;
//     if (requireheader === false) {
//       config.headers["Content-Type"] = "application/json";
//       return config;}
//     else {
//     config.headers["Client-App-Key"] = process.env.REACT_APP_API_KEY;
//     config.headers["Client-App-Type"] = process.env.REACT_APP_API_TYPE;

//     config.headers["Content-Type"] = "application/json";

//     return config;
//     }
//   },
//   (error) => Promise.reject(error)
// );

// import axios from 'axios';

axios.interceptors.request.use(
  config => {
    // Normalize method to lowercase
    const method = config.method?.toLowerCase();

    // Check if request has FormData (used for file uploads)
    const isFormData = config.data instanceof FormData;

    // Example: Match certain URL patterns (e.g., file uploads)
    const isUploadEndpoint = /\/upload/i.test(config.url || '');
    const requireheader = config?.requireheader;
      if (requireheader === false) {
         config.headers["Content-Type"] = "application/json";
         return config;}
      else {
        config.headers["Client-App-Key"] = process.env.REACT_APP_API_KEY;
        config.headers["Client-App-Type"] = process.env.REACT_APP_API_TYPE;
       }
    if (isFormData || isUploadEndpoint) {
      // Don't set Content-Type manually for FormData (let browser set boundary)
      delete config.headers['Content-Type'];
    } else if (method === 'post' || method === 'put' || method === 'patch') {
      // Set JSON Content-Type for typical data submissions
      config.headers['Content-Type'] = 'application/json';
    } else if (method === 'get' && config.params) {
      // Optional: For GET with params, you usually don’t need Content-Type
      delete config.headers['Content-Type'];
    }

    return config;
  },
  error => Promise.reject(error)
);




const rootElement = document.getElementById("root");
if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    // <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
   
        <BrowserRouter>
          <AllRoutes />
          <Toaster />
          <TranslateComponent />
        </BrowserRouter>
      
      </PersistGate>
    </Provider>
    // </React.StrictMode>
  );
} else {
  console.error("Element with id 'root' not found.");
}
